import * as React from 'react';

function SvgFileIcon(props) {
  return (
    <svg
      width={28}
      height={28}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect opacity={0.15} width={28} height={28} rx={3} fill="#232340" />
      <g clipPath="url(#file-icon_svg__clip0)" fill="#232340">
        <path d="M21 13.074a3.391 3.391 0 00-1.034-2.43 3.332 3.332 0 00-2.01-.925.145.145 0 01-.112-.07 4.483 4.483 0 00-8.225 1.338.146.146 0 01-.133.117A2.677 2.677 0 007 13.772a2.523 2.523 0 00.72 1.872 3.219 3.219 0 002.104.806.584.584 0 00-.018-1.167 1.918 1.918 0 01-1.267-.466 1.386 1.386 0 01-.373-1.045 1.503 1.503 0 011.154-1.468c.219-.053.447-.057.667-.011a.584.584 0 00.7-.536 3.316 3.316 0 016.312-1.218.562.562 0 00.549.332 2.158 2.158 0 011.608.613 2.188 2.188 0 01.677 1.59 2.238 2.238 0 01-2.005 2.21.584.584 0 10.153 1.156A3.388 3.388 0 0021 13.074z" />
        <path d="M14.413 12.243a.583.583 0 00-.825 0l-2.042 2.042a.584.584 0 00.413.998h1.02a.145.145 0 01.146.146v4.23a.875.875 0 101.75 0v-4.23a.145.145 0 01.146-.146h1.02a.584.584 0 00.413-.995l-2.041-2.045z" />
      </g>
      <defs>
        <clipPath id="file-icon_svg__clip0">
          <path fill="#fff" transform="translate(7 7)" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgFileIcon;
